import React from 'react';
import { componentService } from 'js/services/component.service';

export const PlayerLimitsReviewReminder = React.lazy(() => import(/* webpackChunkName: "player-limits-review-reminder" */ './PlayerLimitsReviewReminder'));

componentService.registerPageComponents({ 'player-limits-review-reminder': PlayerLimitsReviewReminder });
